/* eslint-disable */
import React, { useMemo, useState, useEffect } from "react";
import { ErrorMessage, Field, FieldProps, Form, Formik } from "formik";
import * as Style from "../../style";
import { FormValues, TModalEditProfile } from "./types";
import { Modal, Select } from "antd";
import { formatCPF } from "../../../../utils/formatter";
import { formatDate as formatDateBr } from "../../../../utils/formatDate";
import { getSchemaTitular } from "../../../../helpers/schemaTitular";
import { FaUser } from "react-icons/fa";
import ReactInputMask from "react-input-mask";
import Can from "../../../Can";
import DSButton from "../../../DSButton";

const { Option } = Select;

const ModalEditProfile: React.FC<TModalEditProfile> = ({
  client,
  isOpenModalPersonalData,
  toggleModalPersonalData,
  handleSubmitFormModal,
  hasPermissionView,
  hasPermissionToEditPersonalData,
  ufs,
  disabledButtonModal,
  loading,
}) => {
  const initialValues = useMemo(() => {
    const cleanRgData = {
      rg: "",
      orgaoEmissor: "",
      unidadeFederativaRG: "",
      dataEmissao: "",
    };

    const apiRg = client?.client?.rg;
    const apiOrgaoEmissorCompleto = client?.client?.orgaoEmissorRg;
    const apiDataEmissao = client?.client?.dataEmissaoRg;

    if (typeof apiRg === "object" && apiRg !== null) {
      cleanRgData.rg = apiRg.rg || "";
      cleanRgData.orgaoEmissor = apiRg.orgaoEmissor || "";
      if (apiRg.orgaoEmissor) {
        cleanRgData.unidadeFederativaRG = apiRg.orgaoEmissor.slice(-2) || "";
      }
    } else if (typeof apiRg === "string" && apiRg && apiRg !== "undefined") {
      cleanRgData.rg = apiRg;
    }

    if (apiOrgaoEmissorCompleto) {
      cleanRgData.orgaoEmissor =
        apiOrgaoEmissorCompleto.slice(0, -2).trim() || cleanRgData.orgaoEmissor;
      cleanRgData.unidadeFederativaRG =
        apiOrgaoEmissorCompleto.slice(-2) || cleanRgData.unidadeFederativaRG;
    }

    const dataEmissaoClient = apiRg?.dataEmissao || apiDataEmissao;
    cleanRgData.dataEmissao = dataEmissaoClient
      ? formatDateBr(dataEmissaoClient)
      : "";

    return {
      nome: client?.client?.name || "",
      nomeSocial: client?.client?.socialName || "",
      email: client?.client?.email || "",
      birthday:
        client?.client?.dataNascimento || client?.client?.birthday
          ? formatDateBr(
              String(
                client?.client?.dataNascimento || client?.client?.birthday
              )
            )
          : "",
      cpf: client?.client?.cpf ? formatCPF(client.client.cpf) : "",
      rg: cleanRgData.rg,
      orgaoEmissor: cleanRgData.orgaoEmissor,
      dataEmissao: cleanRgData.dataEmissao,
      unidadeFederativaRG: cleanRgData.unidadeFederativaRG,
    };
  }, [client]);

  const validationSchema = useMemo(
    () => getSchemaTitular(initialValues),
    [initialValues]
  );

  return (
    <Modal
      title="Editar perfil"
      visible={isOpenModalPersonalData}
      onCancel={toggleModalPersonalData}
      width={600}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
    >
      <Style.ModalTitular>
        <Formik<FormValues>
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { setErrors }) =>
            handleSubmitFormModal(values, initialValues, setErrors)
          }
          enableReinitialize
        >
          {({ resetForm, setFieldValue, dirty, values }) => {
            const [isRgGroupDirty, setIsRgGroupDirty] = useState(false);

            useEffect(() => {
              const hasChanged =
                (values.rg || "") !== (initialValues.rg || "") ||
                (values.orgaoEmissor || "") !==
                  (initialValues.orgaoEmissor || "") ||
                (values.dataEmissao || "") !==
                  (initialValues.dataEmissao || "") ||
                (values.unidadeFederativaRG || "") !==
                  (initialValues.unidadeFederativaRG || "");

              setIsRgGroupDirty(hasChanged);
            }, [
              values.rg,
              values.orgaoEmissor,
              values.dataEmissao,
              values.unidadeFederativaRG,
              initialValues,
            ]);

            const showRgAsterisk = isRgGroupDirty;

            return (
              <Form>
                <div className="modal-titular__left">
                  <div className="modal-titular__title">
                    <p>
                      <FaUser /> Dados pessoais do titular
                    </p>
                  </div>

                  <div className="modal-titular__content">
                    <div className="item-input">
                      <label htmlFor="nome">
                        Nome <span>*</span>
                      </label>
                      <Field name="nome">
                        {({ field, meta }: FieldProps<string>) => (
                          <input
                            id={field.name}
                            className={
                              meta.touched && meta.error ? "error-id" : ""
                            }
                            type="text"
                            placeholder="Nome"
                            disabled={!hasPermissionToEditPersonalData}
                            {...field}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="nome"
                        className="error"
                        component="span"
                      />
                    </div>

                    <div className="item-input">
                      <label htmlFor="nomeSocial">Nome Social</label>
                      <Field name="nomeSocial">
                        {({ field, meta }: FieldProps<string>) => (
                          <input
                            id={field.name}
                            className={
                              meta.touched && meta.error ? "error-id" : ""
                            }
                            type="text"
                            placeholder="Nome Social"
                            disabled={!hasPermissionToEditPersonalData}
                            {...field}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="nomeSocial"
                        className="error"
                        component="span"
                      />
                    </div>

                    <div className="item-input">
                      <label htmlFor="email">
                        E-mail <span>*</span>
                      </label>
                      <Field name="email">
                        {({ field, meta }: FieldProps<string>) => (
                          <input
                            id={field.name}
                            className={
                              meta.touched && meta.error ? "error-id" : ""
                            }
                            type="text"
                            placeholder="E-mail"
                            disabled={!hasPermissionToEditPersonalData}
                            {...field}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="email"
                        className="error"
                        component="span"
                      />
                    </div>

                    {hasPermissionView && (
                      <div className="grid-2">
                        <div className="item-input">
                          <label htmlFor="birthday">
                            Data de nascimento <span>*</span>
                          </label>
                          <Field name="birthday">
                            {({ field, meta }: FieldProps<string>) => (
                              <ReactInputMask
                                id={field.name}
                                placeholder="Data de nascimento"
                                mask="99/99/9999"
                                maskChar=""
                                autoComplete="none"
                                className={
                                  meta.touched && meta.error ? "error-id" : ""
                                }
                                disabled={!hasPermissionToEditPersonalData}
                                {...field}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="birthday"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="item-input">
                          <label htmlFor="cpf">
                            CPF <span>*</span>
                          </label>
                          <Field name="cpf">
                            {({ field, meta }: FieldProps<string>) => (
                              <ReactInputMask
                                id={field.name}
                                placeholder="CPF"
                                readOnly
                                mask="999.999.999-99"
                                maskChar=""
                                autoComplete="none"
                                className={
                                  meta.touched && meta.error ? "error-id" : ""
                                }
                                disabled={!hasPermissionToEditPersonalData}
                                {...field}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="cpf"
                            className="error"
                            component="span"
                          />
                        </div>
                      </div>
                    )}

                    {hasPermissionView && (
                      <div className="grid-2">
                        <div className="item-input">
                          <label htmlFor="rg">
                            RG {showRgAsterisk && <span>*</span>}
                          </label>
                          <Field name="rg">
                            {({ field, meta }: FieldProps<string>) => (
                              <input
                                id={field.name}
                                className={
                                  meta.touched && meta.error ? "error-id" : ""
                                }
                                type="text"
                                placeholder="RG"
                                disabled={!hasPermissionToEditPersonalData}
                                {...field}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="rg"
                            className="error"
                            component="span"
                          />
                        </div>
                        <div className="item-input">
                          <label htmlFor="dataEmissao">
                            Data de Emissão {showRgAsterisk && <span>*</span>}
                          </label>
                          <Field name="dataEmissao">
                            {({ field, meta }: FieldProps<string>) => (
                              <ReactInputMask
                                id={field.name}
                                placeholder="Data de Emissão"
                                mask="99/99/9999"
                                maskChar=""
                                autoComplete="none"
                                className={
                                  meta.touched && meta.error ? "error-id" : ""
                                }
                                disabled={!hasPermissionToEditPersonalData}
                                {...field}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="dataEmissao"
                            className="error"
                            component="span"
                          />
                        </div>
                      </div>
                    )}

                    {hasPermissionView && (
                      <div className="grid-2">
                        <div className="item-input">
                          <label htmlFor="orgaoEmissor">
                            Orgão Emissor {showRgAsterisk && <span>*</span>}
                          </label>
                          <Field name="orgaoEmissor">
                            {({ field, meta }: FieldProps<string>) => (
                              <input
                                id={field.name}
                                className={
                                  meta.touched && meta.error ? "error-id" : ""
                                }
                                type="text"
                                placeholder="Ex: SSP"
                                disabled={!hasPermissionToEditPersonalData}
                                {...field}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="orgaoEmissor"
                            className="error"
                            component="span"
                          />
                        </div>

                        <div className="item-input">
                          <label htmlFor="unidadeFederativaRG">
                            UF Orgão Emissor {showRgAsterisk && <span>*</span>}
                          </label>
                          <Field name="unidadeFederativaRG">
                            {({ field, meta }: FieldProps<string>) => (
                              <Select
                                id={field.name}
                                {...field}
                                value={field?.value || undefined}
                                disabled={!hasPermissionToEditPersonalData}
                                onChange={(value) =>
                                  setFieldValue("unidadeFederativaRG", value)
                                }
                                className={
                                  meta.touched && meta.error ? "error-id" : ""
                                }
                                showSearch
                                placeholder="Ex: SP"
                              >
                                {ufs.map((value) => (
                                  <Option
                                    key={`tab-titular-uf-rg-${value}`}
                                    value={value}
                                  >
                                    {value}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          </Field>
                          <ErrorMessage
                            name="unidadeFederativaRG"
                            className="error"
                            component="span"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <Can permission="edit_personal_data">
                  <div className="footer-modal">
                    <button
                      type="button"
                      onClick={() => {
                        toggleModalPersonalData();
                        resetForm();
                      }}
                      disabled={loading}
                    >
                      Cancelar
                    </button>
                    <DSButton
                      buttonText="Salvar"
                      buttonType="primary"
                      disabled={!dirty || disabledButtonModal}
                      isLoading={loading}
                      type="submit"
                      className="editSubmit"
                    />
                  </div>
                </Can>
              </Form>
            );
          }}
        </Formik>
      </Style.ModalTitular>
    </Modal>
  );
};

export default ModalEditProfile;
